import './S_FieldLabel.scss';
import { observer } from 'mobx-react-lite';
import { ReactElement, ReactNode } from 'react';

interface S_FieldLabelProps {
  text?: string;
  isRequired?: boolean;
  children?: ReactNode;
}

export const S_FieldLabel = observer(
  (props: S_FieldLabelProps): ReactElement => (
    <label className='s-field-label'>
      <span>{props.text || props.children}</span>
      <span className='required-tag'>{props.isRequired ? ' *' : ''}</span>
    </label>
  )
);
